import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    if (isHome) {
      const element = document.getElementById(targetId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    } else {
      navigate('/', { state: { scrollTo: targetId } });
    }
  };

  return (
    <footer className="bg-brand-text text-brand-bg py-12 md:py-24 dark-selection">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="col-span-1 md:col-span-2">
          <Link 
            to="/" 
            onClick={(e) => {
              if (isHome) {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
            className="inline-block hover:opacity-80 transition-opacity"
          >
            <img src="/images/logo/51north-logo-negative.svg" alt="51North" className="h-8 w-auto mb-4" />
          </Link>
          <p className="font-inter text-brand-bg/70 max-w-sm mt-4">
            Die serielle Modulbauweise für Ihr neues Eigenheim. Präzision, Struktur und garantierte Kostensicherheit für die Entwicklung von morgen.
          </p>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-brand-bg/50 mb-6">Navigation</h4>
          <ul className="space-y-3 font-inter">
            <li>
              <button onClick={(e) => handleNavClick(e, 'about')} className="hover:text-brand-bg/70 transition-colors text-left">Über uns</button>
            </li>
            <li>
              <button onClick={(e) => handleNavClick(e, 'method')} className="hover:text-brand-bg/70 transition-colors text-left">Methode</button>
            </li>
            <li>
              <button onClick={(e) => handleNavClick(e, 'portfolio')} className="hover:text-brand-bg/70 transition-colors text-left">Portfolio</button>
            </li>
            <li>
              <button onClick={(e) => handleNavClick(e, 'team')} className="hover:text-brand-bg/70 transition-colors text-left">Team</button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-brand-bg/50 mb-6">Rechtliches</h4>
          <ul className="space-y-3 font-inter">
            <li><Link to="/impressum" className="hover:text-brand-bg/70 transition-colors">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-brand-bg/70 transition-colors">Datenschutz</Link></li>
            <li><Link to="/cookie-richtlinien" className="hover:text-brand-bg/70 transition-colors">Cookie-Richtlinien</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 mt-24 pt-8 border-t border-brand-bg/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="font-mono text-xs text-brand-bg/50">
          © 2026 51north Real Estate GmbH. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};

export default Footer;